import { Card, CardContent, Typography, Box } from '@mui/material';
import type { KpiMetric } from '@azoupvendas/shared';

// AIDEV-NOTE: Card KPI reutilizavel — valor grande, label secundario, trend opcional
interface KpiCardProps {
  metric: KpiMetric;
}

function formatValue(value: number, unit: KpiMetric['unit']): string {
  switch (unit) {
    case 'currency':
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    case 'percent':
      return `${value.toFixed(1)}%`;
    case 'number':
    default:
      return value.toLocaleString('pt-BR');
  }
}

export function KpiCard({ metric }: KpiCardProps) {
  const { label, value, unit, delta } = metric;
  const hasTrend = delta !== undefined && delta !== null;
  const trendPositive = hasTrend && delta > 0;
  const trendNegative = hasTrend && delta < 0;

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        <Typography variant="h4" component="div" fontWeight="bold" data-testid="kpi-value">
          {formatValue(value, unit)}
        </Typography>
        {hasTrend && (
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
            <Typography
              variant="body2"
              data-testid="kpi-trend"
              sx={{
                color: trendPositive
                  ? 'success.main'
                  : trendNegative
                    ? 'error.main'
                    : 'text.secondary'
              }}
            >
              {trendPositive ? '\u25B2' : trendNegative ? '\u25BC' : ''}{' '}
              {Math.abs(delta).toFixed(1)}%
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
